import styled from '@emotion/styled';
import { BREAKPOINTS } from '../../utils/consts';
import { DOWNLOAD_DATA_DEFINITION } from '../../utils/consts';
import Button from '../Shared/Button';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { getKmlByName } from '../../services/getGeojsonData.service';

function DownloadTable() {

    const prepareKmlBlob = (data: any): Blob | null => {
        if (!data) {
            return null;
        }

        if (data instanceof Blob) {
            return data;
        }

        if (typeof data === 'string') {
            return new Blob([data], { type: 'application/vnd.google-earth.kml+xml;charset=utf-8' });
        }

        if (typeof data?.kml === 'string') {
            return new Blob([data.kml], { type: 'application/vnd.google-earth.kml+xml;charset=utf-8' });
        }

        if (typeof data?.content === 'string') {
            return new Blob([data.content], { type: 'application/vnd.google-earth.kml+xml;charset=utf-8' });
        }

        return null;
    };

    const handleDownload = async (tableName: string) => {
        try {
            const data = await getKmlByName(tableName);

            if (typeof data?.url === 'string') {
                window.open(data.url, '_blank');
                return;
            }

            const blob = prepareKmlBlob(data);
            if (!blob) {
                console.error('Unexpected KML response format for table:', tableName, data);
                return;
            }

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `${tableName}.kml`;
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error(`Failed to download KML for ${tableName}:`, error);
        }
    };

    return (
        <TableScrollContainer>
            <TableContainer>
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Last Updated</th>
                        <th>Data Type</th>
                        <th>Download</th>
                    </tr>
                </thead>
                <tbody>
                    {DOWNLOAD_DATA_DEFINITION.map((data, index) => (
                        <tr key={index}>
                            <td>{data.name}</td>
                            <td>{data.last_updated}</td>
                            <td>{data.data_type}</td>
                            <td>
                                <Button icon={faDownload} filledStyle={true} onClick={() => handleDownload(data.download_link)}>
                                    Download
                                </Button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </TableContainer>
        </TableScrollContainer>
    )
}

export default DownloadTable;

const TableScrollContainer = styled.div`
    width: 100%;
    max-width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
`;

const TableContainer = styled.table<{}>(() => `
    width: 100%;
    border-collapse: collapse;
    margin: 20px 0;
    font-size: 1em;
    font-family: 'Arial', sans-serif;
    min-width: 640px;

    th, td {
        padding: 12px 15px;
        text-align: left;
        border-bottom: 1px solid #e0e0e0;
    }

    thead th {
        background-color:rgba(245, 245, 245, 0.9);
        font-weight: 600;
    }

    tbody tr {
        transition: background-color 0.3s ease;
    }

    tbody tr:hover {
        background-color: #f9f9f9;
    }

    a {
        color: #009879;
        text-decoration: none;
        transition: color 0.3s ease;
    }

    a:hover {
        color: #007f5f;
    }

        @media (max-width: ${BREAKPOINTS.MOBILE}) {
            font-size: 0.9em;

            th, td {
                padding: 10px;
            }
        }
`)